import React from "react";
import { Box, Flex, HStack, Icon, Link as ChakraLink, SimpleGrid, Stack, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa";
import { ArawaksLogo } from "components/utils/ArawaksLogo";

const FooterLink = ({ children, ...props }) => (
  <ChakraLink color="whiteAlpha.800" fontSize="sm" fontWeight="600" _hover={{ color: "white" }} {...props}>
    {children}
  </ChakraLink>
);

const Footer = () => (
  <Box as="footer" bg="public.bg.footer" color="white" px={{ base: 5, md: 10, lg: 20 }} pt={{ base: 8, md: 14 }} pb={{ base: "calc(96px + env(safe-area-inset-bottom))", md: 7 }}>
    <Flex display={{ base: "flex", md: "none" }} align="center" justify="space-between" gap="5">
      <ArawaksLogo variant="white" alt="Arawaks" w="126px" />
      <FooterLink href="/NormasConvivenciaClubArawaks.pdf" target="_blank" rel="noreferrer">
        Normas de convivencia
      </FooterLink>
    </Flex>

    <SimpleGrid display={{ base: "none", md: "grid" }} columns={{ md: 2, lg: 4 }} gap="10" pb="12">
      <Stack gap="4">
        <ArawaksLogo variant="white" alt="Arawaks" w="158px" />
        <Text maxW="300px" color="whiteAlpha.700" fontSize="sm" lineHeight="tall">
          Una comunidad para crecer, explorar y vivir grandes aventuras.
        </Text>
        <HStack gap="4">
          <ChakraLink aria-label="Instagram" color="whiteAlpha.900" href="https://www.instagram.com/arawaks/" target="_blank" rel="noreferrer" _hover={{ color: "white" }}><Icon as={FaInstagram} boxSize="20px" /></ChakraLink>
          <ChakraLink aria-label="Facebook" color="whiteAlpha.900" href="https://www.facebook.com/clubarawaks" target="_blank" rel="noreferrer" _hover={{ color: "white" }}><Icon as={FaFacebook} boxSize="20px" /></ChakraLink>
          <ChakraLink aria-label="YouTube" color="whiteAlpha.900" href="https://www.youtube.com/@clubarawaks7844" target="_blank" rel="noreferrer" _hover={{ color: "white" }}><Icon as={FaYoutube} boxSize="20px" /></ChakraLink>
        </HStack>
      </Stack>

      <Stack gap="3">
        <Text fontFamily="heading" fontSize="lg" fontWeight="700">Explora</Text>
        <FooterLink as={Link} to="/">Inicio</FooterLink>
        <FooterLink as={Link} to="/actividades">Actividades</FooterLink>
        <FooterLink as={Link} to="/contacto">Contacto</FooterLink>
        <FooterLink as={Link} to="/registro">Registro</FooterLink>
      </Stack>

      <Stack gap="3">
        <Text fontFamily="heading" fontSize="lg" fontWeight="700">Contacto</Text>
        <FooterLink href="https://www.google.com/maps?q=Club+Arawaks" target="_blank" rel="noreferrer">Río Danubio 128<br />Del Valle, 66220</FooterLink>
        <FooterLink href="mailto:awk@arawaks.org">awk@arawaks.org</FooterLink>
      </Stack>

      <Stack gap="3">
        <Text fontFamily="heading" fontSize="lg" fontWeight="700">Documentos</Text>
        <FooterLink href="/NormasConvivenciaClubArawaks.pdf" target="_blank" rel="noreferrer">Normas de convivencia</FooterLink>
      </Stack>
    </SimpleGrid>

    <Flex mt={{ base: 6, md: 0 }} pt={{ base: 5, md: 6 }} borderTopWidth="1px" borderColor="whiteAlpha.200" justify={{ base: "center", md: "space-between" }}>
      <Text color="whiteAlpha.600" fontSize={{ base: "10px", md: "xs" }} textAlign="center">
        Copyright © {new Date().getFullYear()} Club Arawaks. Todos los derechos reservados.
      </Text>
    </Flex>
  </Box>
);

export default Footer;
